<template>
  <RouterView />
</template>

<script>
import { READ } from '@/plugins/user'
export default {
  data () {
    return {
      breadcrumb: {
        name: new Promise(resolve => {
          this.$sdk
            .consignment
            .read(this.$route.params.consignmentId)
            .then((response) => {
              resolve(response.con_full)
            })
        }),
        route: { name: 'freight-consignments-v3-consignment', params: { consignmentId: this.$route.params.consignmentId } }
      },
      sidebar: [
        {
          hidden: this.$user.cannot(READ, this.$sdk.consignment),
          icon: ['fal', 'file-invoice'],
          route: { name: 'freight-consignments-v3-consignment-details', params: { consignmentId: this.$route.params.consignmentId } },
          name: 'Details'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.consignment),
          icon: ['fal', 'sticky-note'],
          route: { name: 'freight-consignments-v3-consignment-notes', params: { consignmentId: this.$route.params.consignmentId } },
          name: 'Notes'
        },
        // {
        //   hidden: this.$user.cannot(READ, this.$sdk.consignment),
        //   icon: ['fal', 'sack-dollar'],
        //   route: { name: 'freight-consignments-v3-consignment-pricing', params: { consignmentId: this.$route.params.consignmentId } },
        //   name: 'Pricing'
        // },
        // {
        //   hidden: this.$user.cannot(READ, this.$sdk.consignment),
        //   icon: ['fal', 'history'],
        //   route: { name: 'freight-consignments-v3-consignment-history', params: { consignmentId: this.$route.params.consignmentId } },
        //   name: 'History'
        // },
        {
          hidden: this.$user.cannot(READ, this.$sdk.consignment),
          icon: ['fal', 'book'],
          route: { name: 'freight-consignments-v3-consignment-manifest', params: { consignmentId: this.$route.params.consignmentId } },
          name: 'Manifest'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.consignment),
          icon: ['fal', 'ambulance'],
          route: { name: 'freight-consignments-v3-consignment-enquiries', params: { consignmentId: this.$route.params.consignmentId } },
          name: 'Enquiries'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.consignment),
          icon: ['fal', 'paperclip'],
          route: { name: 'freight-consignments-v3-consignment-attachments', params: { consignmentId: this.$route.params.consignmentId } },
          name: 'Attachments'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.consignment),
          icon: ['fal', 'eye'],
          route: { name: 'freight-consignments-v3-consignment-watchlist', params: { consignmentId: this.$route.params.consignmentId } },
          name: 'Watchlist'
        }
      ]
    }
  }
}
</script>
